/**
 * 時刻に関する汎用関数を定義する
 */


/**
 * 現在のタイムスタンプと，タイムスタンプの配列から，前方と後方に際近傍となるタイムスタンプの情報を取得する
 * @param {*} currentTimestamp 秒のタイムスタンプ
 * @param {*} timestamps 到着時刻群の配列（秒のタイムスタンプで昇順であることが前提）
 * @param {*} cycleEnd タイムスタンプのサイクルの最大値（デフォルト：秒の 24:00:00 ）
 * @returns 
 */
export function getClosestTimestamp(currentTimestamp, timestamps, cycleEnd = 60 * 60 * 24) {

    const normalizedCurrent = currentTimestamp % cycleEnd;

    // 各タイムスタンプを正規化
    const normalizedTimestamps = timestamps.map(time => time % cycleEnd);

    // 超えた（または同じ）タイムスタンプをフィルタリング
    const validTimestamps = normalizedTimestamps
        .map((time, index) => ({ time, index })) // インデックス情報を保持
        .filter(entry => entry.time <= normalizedCurrent);

    let closest, next;
    if (validTimestamps.length === 0) {
        // 超えた要素がない場合、最大値を使用
        const maxTime = Math.max(...normalizedTimestamps);
        const maxIndex = normalizedTimestamps.indexOf(maxTime);
        closest = { time: maxTime, index: maxIndex };

        // 次のインデックスは先頭（ループ処理）
        const nextIndex = (maxIndex + 1) % timestamps.length;
        next = { time: normalizedTimestamps[nextIndex], index: nextIndex };
    } else {
        // 超えた要素の中で最大のものを取得
        closest = validTimestamps.reduce((max, entry) =>
            entry.time > max.time ? entry : max
        );

        // 次のインデックスはループ処理を考慮
        const nextIndex = (closest.index + 1) % timestamps.length;
        next = { time: normalizedTimestamps[nextIndex], index: nextIndex };
    }

    // 相対経過時間を計算
    const relativeTimeToClosest = (normalizedCurrent - closest.time + cycleEnd) % cycleEnd;
    const relativeTimeToNext = (next.time - normalizedCurrent + cycleEnd) % cycleEnd;

    return {
        closestIndex: closest.index,
        relativeTimeToClosest,
        nextIndex: next.index,
        relativeTimeToNext,
    };
}


/**
 * currentTimeを24時間表記に変換
 * @param {number} timestamp - 秒のタイムスタンプ
 * @returns stringのHH:MM:SS
 */
export function formatTime(timestamp) {
    const date = new Date(timestamp * 1000); // 秒をミリ秒に変換
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

/**
 * currentTimeを24時間表記に変換
 * @param {number} timestamp - 秒のタイムスタンプ
 * @returns stringのHH:MM
 */
export function formatHHMM(timestamp) {
    const date = new Date(timestamp * 1000); // 秒をミリ秒に変換
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

/**
 * 現在の日付を返す
 * @returns 
 */
export function getYYYYMMDD() {
    const today = new Date();
    const year = today.getFullYear(); // 年を取得
    const month = String(today.getMonth() + 1).padStart(2, '0'); // 月を取得（0始まりなので+1）。2桁に整形
    const day = String(today.getDate()).padStart(2, '0'); // 日を取得。2桁に整形
    return `${year}.${month}.${day}`; // フォーマット: YYYY.MM.DD
}